var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 52,
    viewBox: "0 0 29 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5167 39.8846H0.0884094V51.2564H28.5167V39.8846Z",
    fill: "#52B0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.088501 28.4326L9.58354 26.6134C9.8581 29.8537 11.0919 32.8474 14.3327 32.8474C16.833 32.8474 18.6238 31.6217 18.6238 28.7737V0.743835H28.5168V26.4426C28.5168 36.5064 24.3662 40.6569 14.3025 40.6569C3.89798 40.6569 0.884545 34.5735 0.088501 28.4326Z",
    fill: "#050000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJLogo);
export default __webpack_public_path__ + "static/media/j-logo.1a255bc793e69dd328b9a4feecf83459.svg";
export { ForwardRef as ReactComponent };